import { CollapsibleItemsList } from '@app/components/products/CollapsibleItemsList';
import cx from 'classnames';

interface Props {
  items: JSX.Element | JSX.Element[];
  variant?: 'gray' | 'white';
}

const VERTICAL_OFFSET = -34;
const HORIZONTAL_OFFSET = -12;

export const CollapsibleListCell = ({ items, variant = 'white' }: Props) => {
  return (
    <CollapsibleItemsList
      popoverVerticalOffset={VERTICAL_OFFSET}
      popoverClassName={cx('text-neutral-20 body-2 p-[14px]', { 'bg-neutral-98': variant === 'gray' })}
      popoverHorizontalOffset={HORIZONTAL_OFFSET}
      triggerClassName="relative z-interactiveTableItem"
    >
      {items}
    </CollapsibleItemsList>
  );
};
